<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <permission-btn moduleName='tx_venInfos' size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <!--      栅格布局-->
      <el-row class="fh">
        <el-col :span="8" class="fh ls-border">
          <el-card shadow="never" class="card-body-none fh" style="overflow-y: auto">
            <div slot="header" class="clearfix">
              <!--              点击所有存货，展示所有数据-->
              <el-button type="text" style="padding: 0 11px" @click="getAllMenus">所有供应商>></el-button>
            </div>
            <!--            树形结构的表格   columns：查看所选择的某一个连续范围内的一系列单元格的总列数-->
            <tree-table highlight-current-row :data="modulesTree" :columns="columns" @row-click="treeClick"
                        border></tree-table>
          </el-card>
        </el-col>
        <el-col :span="16" class="fh ls-border">
          <div class="bg-white fh" id='txVenInfos-table'>
            <el-table ref="mainTable" :key='tableKey' :data="list" v-loading="listLoading" border fit
                      highlight-current-row
                      style="width: 100%;" height="calc(100% - 52px)" @row-click="rowClick"
                      @selection-change="handleSelectionChange" @sort-change="handleSortChange">
              <!--使用服务器返回的表头，如果复杂的表头和格式解析，请自己定义表格格式-->
              <el-table-column type="selection" align="center" width="55"></el-table-column>
              <el-table-column v-for="(item, index) in headerList" :key="index" :min-width="item.width"
                               :label="item.description"
                               :prop="item.key" :align="item.align" :sortable="item.isSort === true ? 'custom' : false"
                               :show-overflow-tooltip="item.tooltip">
                <template slot-scope="scope">
                  <select-type ref="selectType" :isEdit="false" :typeId="item.isSel" v-model="scope.row[item.key]"
                               v-if="item.isSel">
                  </select-type>
                  <span v-else>
                <span
                  v-if="item.type === 'DateTime'&&item.key !== 'createDate'">{{ scope.row[item.key] | dateFormat }}</span>
                <span v-else>{{ scope.row[item.key] }}</span>
              </span>
                </template>
              </el-table-column>
            </el-table>
            <pagination v-show="total>0" :total="total" :page.sync="listQuery.page"
                        :limit.sync="listQuery.limit" @pagination="handleCurrentChange"/>
          </div>
        </el-col>
      </el-row>
      <!--使用createdFormId设置Dialog的id,通过id设置内部的样式，防止样式污染-->
      <add-instance ref="dataForm" :sourceCode="crmType"
                    createdFormId="txVenInfos-dialog"
                    :visible.sync="dialogFormVisible"
                    :initData="initData" :soltNameArray="soltNameArray"
      >
        <treeselect slot="venClass" :normalizer="normalizer" :options="modulesTreeRoots"
                    :default-expand-level="3" :multiple="false" :open-on-click="true" :open-on-focus="true"
                    :clear-on-select="true"
                    v-model="dpSelectModules"></treeselect>
        <!--        表格-->
        <el-table
          slot="lkList"
          :data="initData.lkList"
          border
        >
          <el-table-column type="index" fixed="left" width="50" label="序号"></el-table-column>
          <!--          表格里嵌套input，readonly是设置只读-->
          <el-table-column label="账套名称" prop="accName" align="center" min-width="150">
            <template slot-scope="scope">
              <el-input readonly :value="scope.row.accName"/>
            </template>
          </el-table-column>
          <el-table-column label="Erp供应商编码" prop="linkVenCode" align="center" min-width="300">
            <template slot-scope="scope">
              <!--              显示切换按钮，绑定linkcInvNam和linkcInvCode-->
              <el-input v-if="!scope.row.edit" readonly
                        :value="scope.row.linkVenName?scope.row.linkVenName+'('+scope.row.linkVenCode+')':''">
                <!--                切换的那个按钮-->
                <el-button slot="append" icon="el-icon-search" @click="()=>{rowdearchbtn(scope)}"></el-button>
              </el-input>
              <!--              下拉列表 绑定v-model，filterable是可输入文字进行筛选，remote远程搜素，reserve-keyword：多选且可搜索时，是否在选中一个选项后保留当前的搜索关键词
              remote-method启用远程搜素，自定义方法，@change：里面写的选择下拉列表的某一行
              @ visible-change 函数里面传递两个参数（第一个为回调参数，第二个为自己定义的参数） 下拉框出现/隐藏时触发-->
              <el-select
                v-else
                v-model="scope.row.linkVenCode"
                filterable
                remote
                reserve-keyword
                placeholder="请输入存货编号或者名称"
                :remote-method="(query)=>{remoteMethod(query,scope.row.accountId)}"
                @change="(val)=>{selectChange(val,scope.row)}"
                @visible-change="(val)=>{if(!val){scope.row.edit=false}}"
                :loading="selloading">
                <!--                el-option：下拉绑定   option：树形结构的数据-->
                <el-option
                  v-for="item in options"
                  :key="item.linkVenCode"
                  :label="item.linkVenName+'('+item.linkVenCode+')'"
                  :value="item.linkVenCode">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>

      </add-instance>

      <edit-instance ref="editForm" :sourceCode="crmType"
                     createdFormId="txVenInfos-dialog"
                     :visible.sync="dialogEditVisible"
                     :initData="temp" :soltNameArray="soltNameArray">
        <treeselect slot="venClass" :normalizer="normalizer" :options="modulesTreeRoots"
                    :default-expand-level="3" :multiple="false" :open-on-click="true" :open-on-focus="true"
                    :clear-on-select="true"
                    v-model="dpSelectModules"></treeselect>

        <!--        表格-->
        <el-table
          slot="lkList"
          :data="temp.lkList"
          border
        >
          <el-table-column type="index" fixed="left" width="50" label="序号"></el-table-column>
          <!--          表格里嵌套input，readonly是设置只读-->
          <el-table-column label="账套名称" prop="accName" align="center" min-width="150">
            <template slot-scope="scope">
              <el-input readonly :value="scope.row.accName"/>
            </template>
          </el-table-column>
          <el-table-column label="Erp供应商编码" prop="linkVenCode" align="center" min-width="300">
            <template slot-scope="scope">
              <!--              显示切换按钮，绑定linkcInvNam和linkcInvCode-->
              <el-input v-if="!scope.row.edit" readonly
                        :value="scope.row.linkVenName?scope.row.linkVenName+'('+scope.row.linkVenCode+')':''">
                <!--                切换的那个按钮-->
                <el-button slot="append" icon="el-icon-search" @click="()=>{rowdearchbtn(scope)}"></el-button>
              </el-input>
              <!--              下拉列表 绑定v-model，filterable是可输入文字进行筛选，remote远程搜素，reserve-keyword：多选且可搜索时，是否在选中一个选项后保留当前的搜索关键词
              remote-method启用远程搜素，自定义方法，@change：里面写的选择下拉列表的某一行
              @ visible-change 函数里面传递两个参数（第一个为回调参数，第二个为自己定义的参数） 下拉框出现/隐藏时触发-->
              <el-select
                v-else
                v-model="scope.row.linkVenCode"
                filterable
                remote
                reserve-keyword
                placeholder="请输入存货编号或者名称"
                :remote-method="(query)=>{remoteMethod(query,scope.row.accountId)}"
                @change="(val)=>{selectChange(val,scope.row)}"
                @visible-change="(val)=>{if(!val){scope.row.edit=false}}"
                :loading="selloading">
                <!--                el-option：下拉绑定   option：树形结构的数据-->
                <el-option
                  v-for="item in options"
                  :key="item.linkVenCode"
                  :label="item.linkVenName+'('+item.linkVenCode+')'"
                  :value="item.linkVenCode">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>

      </edit-instance>

      <filter-form ref="queryForm" @filter="handleFilter" :code="crmType"
                   :dialog-visible.sync="dialogQueryVisible"/>

      <my-transfer :code="crmType" @filter="handleFilter"
                   :titles="['待配置列', '显示列']"
                   :dialog-visible.sync="dialogSetVisible"/>

      <drawerViews :drawer.sync="drawer" :tempobj="drawertemp" :objtype="drawerobjtype"
                   :menukeyArray="menukeyArray"></drawerViews>
    </div>
  </div>
</template>

<script>
import * as txVenInfos from '@/api/tx_veninfos';
import mytable from '@/utils/crmtableFlowV2';
import * as accinfos from '@/api/accinfos';
import * as Gerpinventorys from '@/api/Gerpinventorys';
import * as tx_venclasss from '@/api/tx_venclasss';
// 导入树形表格
import treeTable from '@/components/TreeTable';
// 导入树形结构插件
import Treeselect from '@riophae/vue-treeselect';
// 导入样式
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: 'txVenInfos',
  components: { treeTable, Treeselect },
  mixins: [mytable],
  data() {
    return {
      crmType: 'Tx_VenInfo',
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        AccountId: '' // 账套ID
      },
      initData: {
        AccountId: '',
        lkList: [],
        classification: '',
        venClass: ''
      },
      rules: {},
      selloading: false, // 关闭加载旋转
      normalizer(node) {
        // treeselect定义字段
        return {
          label: node.classificationName,
          id: node.classification,
          children: node.children
        };
      },
      options: [], // 树形结构的数据
      selectMenus: [], // 菜单列表选中的值
      modules: [], // 模块
      modulesTree: [], // 树形模块
      soltNameArray: ['venClass', 'lkList'], // 放solt插槽的名称
      columns: [
        // treetable的列名
        {
          text: '供应商分类编号',
          value: 'classification'
        },
        {
          text: '供应商分类名称',
          value: 'classificationName'
        }
      ],
      modulesTrees: [],
      selectMenuss: [], // 菜单列表选中的值
      moduless: []
    };
  },
  // 计算属性
  computed: {
    // 树形数据的属性
    modulesTreeRoots() {
      const root = [{
        classificationName: '根节点',
        parentClassification: '',
        id: '',
        classification: '',
        venClass: ''
      }];
      // 把两个数组合并
      return root.concat(this.modulesTrees);
    },
    dpSelectModules: {
      // 模块编辑框下拉选中的模块
      get: function() {
        if (this.dialogFormVisible) {
          return this.initData.venClass;
        } else {
          return this.temp.venClass;
        }
      },
      set: function(v) {
        // 如果是根节点
        if (v === undefined || v === null || !v) {
          if (this.dialogFormVisible) {
            this.$refs['dataForm'].$refs['frmData'].AssignmentModel('venClass', null);
          } else {
            this.$refs['editForm'].$refs['frmEditData'].AssignmentModel('venClass', null);
          }
          return;
        }
        if (this.dialogFormVisible) {
          this.$refs['dataForm'].$refs['frmData'].AssignmentModel('venClass', v);
        } else {
          this.$refs['editForm'].$refs['frmEditData'].AssignmentModel('venClass', v);
        }
      }
    },
    isRoot: {
      get() {
        return this.chkRoot;
      },
      set(v) {
        this.chkRoot = v;
        if (v) {
          this.temp.parentClassificationName = '根节点';
          this.temp.parentId = null;
        }
        // this.treeDisabled = v
      }
    },
    // 树形数据的属性
    modulesTreeRoot() {
      const root = [{
        name: '根节点',
        parentId: '',
        id: '',
        classification: ''
      }];
      // 把两个数组合并
      return root.concat(this.modulesTree);
    },
    // 分页属性
    currentPageMenus: {
      get() {
        var start = (this.listQuery.page - 1) * this.listQuery.limit;
        var end = (this.listQuery.page * this.listQuery.limit);
        var result = this.list.slice(start, end);
        return result;
      }
    },
    dpSelectModule: {
      // 模块编辑框下拉选中的模块
      get: function() {
        if (this.dialogStatus === 'update') {
          return this.temp.parentId || '';
        } else {
          return '';
        }
      },
      set: function(v) {
        if (v === undefined || v === null || !v) {
          // 如果是根节点
          this.temp.parentClassificationName = '根节点';
          this.temp.parentId = null;
          // this.isRoot = true
          return;
        }
        // this.isRoot = false
        this.temp.parentId = v;
        var parentClassificationName = this.moduless.find(val => {
          return v === val.id;
        }).name;
        this.temp.parentClassificationName = parentClassificationName;
      }
    }
  },
  created() {
    this.initData.AccountId = this.getAccountId(); // 从V2文件中取到账套ID
    this.listQuery.AccountId = this.getAccountId();
  },
  mounted() {
    // 初始化页面完成后，刷新树形结构
    this.getModulesTree();
  },
  methods: {
    getApi() {
      return txVenInfos;
    },
    // 点击所有存货，展示所有数据的方法  listQuery查询
    getAllMenus() {
      this.currentModule = null;
      let whereobj = this.listQuery.wheres ? JSON.parse(this.listQuery.wheres) : [];
      if (whereobj) {
        whereobj = this.AssTableData([{
          field: 'venClass',
          value: null,
          relation: '=='
        }], whereobj);
      }
      this.listQuery.wheres = JSON.stringify(whereobj);
      this.getList();
    },
    // 递归,只需少量程序就可描述出解题过程，大大减少了程序的代码量。函数将自身作为子例程调用。 简单说程序调用自身的编程技巧叫递归
    recursion(array, data) {
      // 定义临时的数组
      const interim = this.modules.filter(u => u.parentClassification === data.classification);
      for (let i = 0; i < interim.length; i++) {
        // 把子集放进去
        array.push(interim[i].classification);
        this.recursion(array, interim[i]);
      }
    },
    // 左侧treetable点击事件
    treeClick(data) {
      // 先定义一个数组,放父级和父级本身以及下面子集的数据
      const array = [];
      // 先把自己放进去
      array.push(data.classification);
      this.recursion(array, data);
      console.log(array);
      this.currentModule = data;
      // this.currentModule.parent = null
      let whereobj = this.listQuery.wheres ? JSON.parse(this.listQuery.wheres) : [];
      if (whereobj) {
        whereobj = this.AssTableData([{
          field: 'venClass',
          value: array.join(),
          relation: 'in'
        }], whereobj);
      }
      this.listQuery.wheres = JSON.stringify(whereobj);
      this.getList();
    },
    // 树结构传出数据方法
    getModulesTree() {
      var _this = this; // 记录vuecomponent
      tx_venclasss.getAllData().then(response => {
        _this.modules = response.result.map(function(item) {
          return {
            id: item.id,
            classification: item.classification,
            classificationName: item.classificationName,
            parentClassification: item.parentClassification

          };
        });
        // 将一个带层级的数据列表转成树结构
        var modulestmp = _this.modules.map(o => ({ ...o }));
        _this.modulesTree = _this.$utils.toArrayTree(modulestmp, {
          key: 'classification',
          parentKey: 'parentClassification',
          strict: true
        });
        var modulestmps = _this.modules.map(o => ({ ...o }));
        // 将一个带层级的数据列表转成树结构
        _this.modulesTrees = _this.$utils.toArrayTree(modulestmps, {
          key: 'classification',
          parentKey: 'parentClassification',
          strict: true
        });
      });
    },
    openDrawer(row, type) { // 打开抽屉
      this.drawerobjtype = type;
      if (type === 'txVenInfos') {
        this.drawertemp = { ...this.drawertemp, ...row };
        this.menukeyArray = [
          { name: '', menukey: 'tx_veninfosview' }
        ]; // 要显示的标签
        this.drawer = true;
      }
    },
    // 绑定添加页面table表格input的数据
    beforCreate() {
      accinfos.getList({
        page: 1,
        limit: 9999
      }).then(res => {
        const lkList = this.$refs['dataForm'].$refs['frmData'].GetModelData('lkList');
        lkList.splice(0);
        res.data.forEach(u => {
          lkList.push({
            accName: u.accName,
            accountId: u.id,
            accYear: u.accYear,
            accCode: u.accCode,
            linkVenCode: '',
            linkVenName: '',
            safetyStock: null,
            edit: false
          });
        });
      });
      this.getModulesTree();
    },
    // 合并两个对象的数据
    beforUpdate() {
      this.temp.lkList = this.temp.lkList.map(u => {
        return {
          ...{ edit: false },
          ...u
        };
      });
      this.getModulesTree();
    },
    // 存货编码的切换按钮
    rowdearchbtn(scope) {
      if (this.dialogStatus === 'update') {
        const tempindex = this.options.findIndex(u => u.linkVenCode === scope.row.linkVenCode);
        if (tempindex < 0 && scope.row.linkVenCode) {
          this.options.splice(0);
          // 添加
          this.options.push({
            linkVenCode: scope.row.linkVenCode,
            linkVenName: scope.row.linkVenName
          });
        }
      }
      // 切换按钮
      scope.row.edit = true;
    },
    // 远程搜素，remotemethod方法添加自定义参数
    remoteMethod(query, accountId) {
      if (query !== '') {
        this.selloading = true;
        const wherestr = [];
        // 添加
        wherestr.push({
          field: 'cVenCode',
          value: query,
          relation: 'no'
        });

        Gerpinventorys.getList({
          page: 1,
          limit: 10,
          wheres: JSON.stringify(wherestr),
          accountId: accountId
        }).then(res => {
          this.options = res.data.map(u => {
            // 返回数据
            return {
              linkVenCode: u.cVenCode,
              linkVenName: u.cVenName
            };
          });
          this.selloading = false;
        }).catch(() => {
          this.selloading = false;
        });
      } else {
        this.options = [];
      }
    },
    // 选择下拉框的方法
    selectChange(val, row) {
      const tempindex = this.options.findIndex(u => u.linkVenCode === val);
      if (tempindex > -1) {
        row.linkVenCode = this.options[tempindex].linkVenCode;
        row.linkVenName = this.options[tempindex].linkVenName;
      }
    }

  }
};
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}

/* 防止样式污染，使用id为每个页面定义表格体高度 */
#txVenInfos-table .el-table__body-wrapper {
  height: calc(100% - 57px) !important;
}
</style>
